import { css } from 'lit'

export default css`
    :host {
        display: flex;
        align-items: center;
    }

    input[type='checkbox']:indeterminate {
        background-color: var(--blue-500);
    }

    input[type='checkbox']:indeterminate:before {
        content: ' ';
        position: relative;
        display: block;
        border-top: 2px solid var(--white);
        border-radius: 8px;
        left: 3px;
        width: 12px;
        top: calc(50% - 1px);
    }

    input[type='checkbox'] {
        width: 20px;
        height: 20px;
        margin: 5px 12px 5px 2px;
        appearance: none;
        border: 1px solid var(--grey5);
        box-shadow: none;
        font-size: 2em;
        border-radius: 4px;
    }

    input[type='checkbox'].error {
        border: 1px solid var(--red);
    }

    input[type='checkbox']:hover {
        border: 1px solid var(--grey4);
    }

    input[type='checkbox']:focus-visible {
        outline-offset: 2px;
        outline: solid 2px var(--focused);
    }

    input[type='checkbox']:checked {
        position: relative;
        border: 1px solid var(--blue-500);
        background-color: var(--blue-500);
    }

    input[type='checkbox']:checked:after {
        position: absolute;
        display: block;
        content: '';
        left: 3px;
        top: 10px;
        background: var(--white);
        width: 2px;
        height: 2px;
        font: 1.5em 'FontAwesome';
        box-shadow:
            2px 0 0 var(--white),
            4px 0 0 var(--white),
            4px -2px 0 var(--white),
            4px -4px 0 var(--white),
            4px -6px 0 var(--white),
            4px -8px 0 var(--white),
            4px -10px 0 var(--white);
        transform: rotate(40deg);
    }

    input[type='checkbox']:disabled {
        position: relative;
        border: 1px solid border var(--grey5);
        background-color: var(--disabled);
        border: 1px solid var(--grey5);
        pointer-events: none;
    }

    input[type='checkbox']:not(:disabled),
    input[type='checkbox']:not(:disabled) + label {
        cursor: pointer;
    }

    input[type='checkbox']:disabled:after {
        position: absolute;
        display: block;
        content: '';
        left: 3px;
        top: 10px;
        background: var(--grey5);
        font: 1.5em 'FontAwesome';
        transform: rotate(40deg);
    }

    input[type='checkbox']:disabled:checked:after {
        box-shadow:
            2px 0 0 var(--grey5),
            4px 0 0 var(--grey5),
            4px -2px 0 var(--grey5),
            4px -4px 0 var(--grey5),
            4px -6px 0 var(--grey5),
            4px -8px 0 var(--grey5),
            4px -10px 0 var(--grey5);
        width: 2px;
        height: 2px;
    }

    label {
        margin-top: 6px;
    }

    label.controlled {
        display: flex;
        cursor: pointer;
        margin: 0;
    }

    label.controlled span {
        align-self: center;
    }
`
